import { Box, Typography } from '@mui/material';
import { theme } from '@store';

import { useActivityLogs } from './hooks';
import { ActivityLogsTable, AddActivityLog } from './components';

export const ActivityLogs = () => {
  const {
    entries,
    count,
    isLoading,
    filters,
    setFilters,
    onSearchChange,
    minutesToday,
    minutesYesterday,
    minutesThisMonth,
    minutesLastMonth,
  } = useActivityLogs();

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          mt: '1rem',
          mb: '2rem',
          width: '100%',
          justifyContent: 'space-between',
          bgcolor: '',
        }}
      >
        <Typography variant='h4'>Activity log</Typography>
        <Box>
          <AddActivityLog variant='create' />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          gap: '1rem',
          pb: '2rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            padding: '24px',
            backgroundColor: theme.palette.common.white,
            border: '1px solid rgba(0, 0, 0, 0.12)',
            width: '100%',
          }}
        >
          <Typography variant='subtitle2'>Minutes today</Typography>
          <Typography variant='h4'>{minutesToday}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            padding: '24px',
            backgroundColor: theme.palette.common.white,
            border: '1px solid rgba(0, 0, 0, 0.12)',
            width: '100%',
          }}
        >
          <Typography variant='subtitle2'>Minutes yesterday</Typography>
          <Typography variant='h4'>{minutesYesterday}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            padding: '24px',
            backgroundColor: theme.palette.common.white,
            border: '1px solid rgba(0, 0, 0, 0.12)',
            width: '100%',
          }}
        >
          <Typography variant='subtitle2'>Minutes this month</Typography>
          <Typography variant='h4'>{minutesThisMonth}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            padding: '24px',
            backgroundColor: theme.palette.common.white,
            border: '1px solid rgba(0, 0, 0, 0.12)',
            width: '100%',
          }}
        >
          <Typography variant='subtitle2'>Minutes last month</Typography>
          <Typography variant='h4'>{minutesLastMonth}</Typography>
        </Box>
      </Box>
      <ActivityLogsTable
        rows={entries}
        filters={filters}
        setFilters={setFilters}
        onSearchChange={onSearchChange}
        totalCount={count}
        loading={isLoading}
      />
    </Box>
  );
};
